import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

//Pour passer à la productio utiliser cette commande : 
  //ng build --prod --base-href "https://gaiadesign.000webhostapp.com/"

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  @ViewChild("videoRef") videoRef: ElementRef<HTMLVideoElement>;
  mail:any = {name:"", email:"", message:""};

  //To show state of sent message
  SubmitStatu:string=""; //success, await, failed

  constructor(private http:HttpClient){}


  //Set Scroll To 0

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.videoRef.nativeElement.load();
      this.videoRef.nativeElement.muted = true;
      this.videoRef.nativeElement.loop = true;
      this.videoRef.nativeElement.play();
    }, 500);
    
  }

  SubmitEmail(){
    this.SubmitStatu='await';
    //Using https://formspree.io/forms/mbjpkzop/submissions services
    //can send mails as a backend service
    if( this.mail.name.length>0 && this.mail.email.length>0 && this.mail.message.length>0 ){
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
      this.http.post('https://formspree.io/f/mvovvrro',
        { name: this.mail.name, replyto: this.mail.email, message: this.mail.message },
        { 'headers': headers }).subscribe(
          response => {
            console.log(response);
            this.SubmitStatu='success';
            this.mail.name="";
            this.mail.email="";
            this.mail.message="";
        }, err =>{
            console.log(err);
            this.SubmitStatu='failed';
        }
      );
    }else
      this.SubmitStatu='failed';
  }
    
  // }

}
